'use client';

import React from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from './drawer-template';
import TableFilters from './table-filters';

export default function TableFiltersDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.TABLE_FILTERS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.TABLE_FILTERS))}
      title="Filters"
    >
      <TableFilters />
    </DrawerTemplate>
  );
}
